throw new Error(
	`There is no default export in this module. Please use named imports like "node-vibrant/browser", "node-vibrant/node", or "node-vibrant/worker".`,
);

export {};
